// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
import React from "react"
import { classNames } from "@plasmicapp/react-web"

export function Frame2Icon(props) {
  const { className, style, title, ...restProps } = props
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 32 20"}
      height={"1em"}
      width={"1em"}
      style={{
        fill: "currentcolor",
        ...(style || {}),
      }}
      className={classNames("plasmic-default__svg", className)}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        d={
          "M27.691 8.763H6.645l4.624-4.624c.638-.638.638-1.594 0-2.232-.638-.638-1.594-.638-2.232 0L1.703 9.24c-.638.638-.638 1.594 0 2.232l7.334 7.334c.638.638 1.594.638 2.232 0 .638-.637.638-1.594 0-2.232l-4.624-4.623h21.046c.797 0 1.595-.638 1.595-1.595s-.798-1.594-1.595-1.594z"
        }
        fill={"currentColor"}
      ></path>
    </svg>
  )
}

export default Frame2Icon
/* prettier-ignore-end */
